import { Button, makeStyles, Snackbar } from '@material-ui/core';
import { Dialog, DialogContent, DialogTitle, Divider, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import MuiAlert from '@material-ui/lab/Alert';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { deletePengeluaran, setMessagePengeluaran } from '../../../config/redux/action';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
const FormDeletePengeluaran = ({HandleClickCloseDeleteDialog,...rest}) => {
    const {data} = useSelector(state=>state.loginReducers);
    const {formDetails,pengeluaranMessage,isLoading} = useSelector(state=>state.pengeluaranReducers);
    const {idpengeluaran,namabarang,variant} = formDetails;
    const [token,setToken] = useState(data.token);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const useStyle = makeStyles((theme)=>({
        titleDialog:{
            width:'400px',
            [theme.breakpoints.down('sm')]:{
                width:'250px',
            },
            textAlign:'center',
        },
        contentDelete:{
            padding:'10px'
        },
        button:{
            display:'flex',
            justifyContent:'space-between',
            paddingBottom:"5px",
        },
        textFiled:{
            width:'100%',
            paddingBottom:"7px",
        },
    }));
    const classes = useStyle();
    const dispatch = useDispatch();
    const [openSnackbar,setOpenSnackbar] = useState(false);
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenSnackbar(false);
        setTimeout(()=>{
            dispatch(setMessagePengeluaran(""));
        },500)
      };
    const onSubmit=()=>{
        dispatch(deletePengeluaran(idpengeluaran,token));
        setOpenSnackbar(true);
        HandleClickCloseDeleteDialog();
    }
    return (
        <div>
            <Dialog open={false} {...rest}>
            <DialogTitle className={classes.titleDialog} id="delete-pengeluaran-dialog">Hapus Data Pengeluaran</DialogTitle>
                <Divider/>
                <DialogContent>
                    <div className={classes.contentDelete}>
                    <Typography align='center'>Apakah anda yakin akan menghapus data pengeluaran</Typography>
                    <Typography align='center'>{namabarang} {variant}?</Typography>
                    </div>
                <div className={classes.button}>
                <Button variant="contained" color="primary" onClick={onSubmit} disabled={isLoading}>Hapus</Button>
                <Button variant="contained" color="secondary" onClick={HandleClickCloseDeleteDialog} disabled={isLoading}>Keluar</Button>
                </div>
                </DialogContent>
            </Dialog>
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={pengeluaranMessage === 'Penghapusan data pengeluaran gudang berhasil' ?"success" :"error"} onClick={HandleClickCloseDeleteDialog}>{pengeluaranMessage}</Alert>
            </Snackbar>
        </div>
    )
}

export default FormDeletePengeluaran
